import { render, staticRenderFns } from "./PuInfo.vue?vue&type=template&id=5f8ffc5e&scoped=true&"
import script from "./PuInfo.vue?vue&type=script&lang=js&"
export * from "./PuInfo.vue?vue&type=script&lang=js&"
import style0 from "./PuInfo.vue?vue&type=style&index=0&id=5f8ffc5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ffc5e",
  null
  
)

export default component.exports